<template>
  <div id="app">
    <router-view />
  </div>
</template>


<script>
export default {
  mounted() {
    window.addEventListener('unload', this.saveState)

    /* 读取本地缓存主题 */
    let t = JSON.parse(localStorage.getItem('bs-theme')) || this.$store.state.theme
    if (t) this.$store.dispatch('themeChange', t)

    this.setRem()

    window.addEventListener('resize', this.setRem)
    /* 查询是否手机端 */
    let isMobileFlag = this._isMobile()
    isMobileFlag = isMobileFlag ? isMobileFlag[0] === "Android" || isMobileFlag[0] === "iPhone" : false
    localStorage.setItem('isMobileFlag', JSON.stringify(isMobileFlag))
  },
  methods: {
    saveState() {
      if (this.$store) {
        localStorage.setItem("fac-state", JSON.stringify(this.$store.state));
      }
    },

    setRem() {
      var whdef = 10 / 1920; // 表示1920的设计图,使用10PX的默认值
      var bodyWidth = document.body.clientWidth;// 当前窗口的宽度
      var rem = bodyWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
      document.getElementsByTagName('html')[0].style.fontSize = rem + 'px';
    },

    // 适配手机端
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
};
</script>

<style lang="scss">
@import "@/lib/scss/animate.scss";

* {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
}
</style>
